import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto w-full max-w-7xl px-6 md:px-10 ${className}`}>{children}</div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`overline text-gold-dark ${className}`}>{children}</span>
);

export const SectionHeading = ({ label, title, intro, align = "left", light = false }) => (
  <div className={`${align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} mb-12`}>
    {label && <Overline className={light ? "text-gold" : ""}>{label}</Overline>}
    <h2 className={`mt-4 font-serif text-4xl md:text-5xl tracking-tight ${light ? "text-white" : "text-navy"}`}>{title}</h2>
    {intro && <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-softgrey-600"}`}>{intro}</p>}
  </div>
);

export const GoldButton = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 rounded-md bg-navy px-6 py-3 text-sm font-semibold text-white transition-[background-color,transform] duration-200 hover:bg-navy-700 hover:-translate-y-0.5 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const OutlineButton = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 rounded-md border border-navy/25 bg-transparent px-6 py-3 text-sm font-semibold text-navy transition-[background-color,color] duration-200 hover:bg-navy hover:text-white ${className}`}
    {...props}
  >
    {children}
  </button>
);

export function useCollection(fetcher, deps = []) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    setLoading(true);
    Promise.resolve(fetcher())
      .then((d) => mounted.current && setData(d || []))
      .catch(() => mounted.current && setData([]))
      .finally(() => mounted.current && setLoading(false));
    return () => { mounted.current = false; };
    // eslint-disable-next-line
  }, deps);
  return { data, loading };
}
